import { maxBy } from "lodash";

export const getMaxSeasonIndex = state => {
  const index = maxBy(state?.leaguesState?.league?.seasons || [], s => s?.index)
    ?.index;
  return isNaN(index) ? 0 : index;
};
